// extracted by mini-css-extract-plugin
export default {"component":"timer_component__4d2J9","time":"timer_time__frB5z","label":"timer_label__F5ujB"};